import InfoIcon from "@mui/icons-material/Info";
import classNames from "classnames";
import globalStyles from "components/shared/MessageBlock/style.module.scss";
import type { CSSProperties } from "react";
import { useTranslation } from "react-i18next";

import localStyles from "./style.module.scss";

interface IChangeEmailProps {
    currentEmail: string;
    newEmail: string | null;
    style?: CSSProperties;
}

const ChangeBeneficiaryEmailMessage = ({ currentEmail, newEmail, style }: IChangeEmailProps) => {
    const { t } = useTranslation();

    return (
        <div
            className={classNames(globalStyles["message-block"], globalStyles["info"], localStyles.container)}
            style={style}
        >
            <div className={localStyles.header}>
                <InfoIcon className={localStyles.icon} />
                <p className={localStyles.title}>{t("EmailChanges.SecurityReason")}</p>
            </div>

            <ul className={localStyles.list}>
                <li>
                    <strong>{t("EmailChanges.CurrentEmailLabel")} :</strong>{" "}
                    <span className={localStyles.email}>{currentEmail}</span>
                </li>
                <li>
                    <strong>{t("EmailChanges.NewEmailLabel")} :</strong>{" "}
                    <span className={localStyles.email}>{newEmail}</span>
                </li>
            </ul>
        </div>
    );
};

export default ChangeBeneficiaryEmailMessage;
